import { Event } from 'src/modules/event/models/event';
import { EventRequest } from 'src/modules/event/models/eventRequest';
import { EventDateFilter, EventSearchFilter } from 'src/modules/event/models/eventSearchFilter';
import { EventSendInviteRequest } from 'src/modules/event/models/eventSendInviteRequest';
import { EventSendEmailRequest } from 'src/modules/event/models/eventSendEamilRequest';
import { EventParticipantTicketSearchFilter } from 'src/modules/event/models/eventParticipantTicketSearchFilter';
import { EventParticipantTicket } from 'src/modules/event/models/eventParticipantTicket';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';
import { setPagingParams } from '../functions/createPagingParams';
import ConsoleHelper from '../functions/consoleHelper';
import { setArrayValue } from '../functions/setArrayValue';
import { createFormData } from '../functions/createFormData';

const controller = 'Event';

export const getAllEvents = (pageIndex, pageSize, sortCol, sortDir, searchFilter?: EventSearchFilter, dateFilter?: EventDateFilter) => {
  ConsoleHelper.log('Filters in getAllEvents', searchFilter, dateFilter);

  let extraQuery = '';
  if (searchFilter) {
    extraQuery += searchFilter.searchString ? `&filter=${searchFilter.searchString}` : '';
    extraQuery += setArrayValue(searchFilter.associationIds, 'associationIds');
    extraQuery += setArrayValue(searchFilter.districtIds, 'districtIds');
  }
  if (dateFilter) {
    extraQuery += dateFilter.startDate ? `&startDate=${dateFilter.startDate}` : '';
    extraQuery += dateFilter.endDate ? `&endDate=${dateFilter.endDate}` : '';
  }
  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}${extraQuery}`;
  ConsoleHelper.log('endpoint', endpoint);
  return AxiosInstance.get<PagedResult<Event>>(endpoint);
};

export const getEventById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<Event>(endpoint);
};

export const createEvent = (data: EventRequest) => {
  const formData = createFormData<EventRequest>(data);
  return AxiosInstance.post(controller, formData);
};

export const createParticipantsAndSendInvite = (eventId: number, data: EventSendInviteRequest) => {
  return AxiosInstance.post(`${controller}/${eventId}/createParticipantsAndSendInvite`, data);
};

export const createEventEmail = (eventId: number, data: EventSendEmailRequest) => {
  return AxiosInstance.post(`${controller}/${eventId}/SendEmail`, data);
};

export const updateEvent = (data: EventRequest) => {
  const formData = createFormData<EventRequest>(data);
  return AxiosInstance.put(controller, formData);
};

export const getEmailTemplate = (id) => {
  const endpoint = `${controller}/${id}/EmailTemplate`;
  return AxiosInstance.get(endpoint);
};

export const deleteEvents = (ids: number[]) => {
  return AxiosInstance.delete(`${controller}/DeleteByIds`, {
    data: { ids },
  });
};

export const getParticipantTicketsForEvent = (
  id: number,
  pageIndex,
  pageSize,
  sortCol,
  sortDir,
  searchFilter?: EventParticipantTicketSearchFilter,
) => {
  let extraQuery = '';

  if (searchFilter) {
    extraQuery += searchFilter.searchString ? `&filter=${searchFilter.searchString}` : '';
    extraQuery += setArrayValue(
      searchFilter.selectedTicketTypes?.map((type) => type.id),
      'eventTicket_id',
    );
  }
  const endpoint = `${controller}/${id}/ParticipantTicket/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<EventParticipantTicket>>(endpoint);
};
